import React from 'react';
import classNames from 'classnames';

import { formatBrand } from 'services/product/formatter';

import styles from './ProductCardLabel.module.scss';

export type Props = {
  label: string;
  brand?: string;
  className?: string;
  classes?: {
    label?: string;
  };
};

export default function ProductCardLabel({
  label,
  brand,
  className,
  classes,
}: Props): JSX.Element {
  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.brand}>{brand && formatBrand(brand)}</div>
      <div className={classNames(styles.label, classes?.label)}>{label}</div>
    </div>
  );
}
